import { anyOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isBaseIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: string,
  connected_at: string,
});

const isGeminiIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: string,
  connected_at: string,
  use_vertex_ai: boolean,
  vertex_project_id: anyOf(string, () => true),
});

const isDatabricksMosaicIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  api_key: string,
  connected_at: string,
  workspace_name: string,
});

export const isGetAlloysProviderAgenticAppGroupIdResult = objectOf({
  integration: anyOf(isGeminiIntegration, isDatabricksMosaicIntegration, isBaseIntegration, objectOf({})),
});
